import React__default from 'react';
import keycode from 'keycode';
import { getNextIndexFromKeycode } from '../../../utils/hooks/useListKeyboardNavigation.js';
import { sanitizeRowProps } from '../util.js';

var useTableKeyboardNavigation = function useTableKeyboardNavigation(props, rows, rowProps, ref) {
  var useGlobalKeyboardNavigation = props.dangerouslyHijackGlobalKeyboardNavigation;

  var _React$useState = React__default.useState(useGlobalKeyboardNavigation ? 0 : undefined),
      activeIndex = _React$useState[0],
      setActiveIndex = _React$useState[1];

  var onKeyDown = function onKeyDown(event) {
    var isModifierKeyPressed = event.metaKey || event.ctrlKey || event.altKey || event.shiftKey;

    if (useGlobalKeyboardNavigation && !(document.activeElement === ref.current || document.activeElement === document.body)) {
      return;
    } // abort key handling if other elements inside table are focused and we don't use global keyboard navigation


    if (!useGlobalKeyboardNavigation && document.activeElement !== ref.current) {
      return;
    }

    if (activeIndex !== undefined) {
      var currentRow = rows[activeIndex];

      if (currentRow) {
        var sanitizedRow = sanitizeRowProps(currentRow, rowProps.rowExpansionRenderer);

        if (rowProps.onRowClick && event.keyCode === keycode('enter')) {
          event.preventDefault();
          rowProps.onRowClick(sanitizedRow);
          return;
        }

        if (currentRow.toggleRowSelected && event.keyCode === keycode('space')) {
          event.preventDefault();
          currentRow.toggleRowSelected();
          return;
        }

        if (currentRow.toggleRowExpanded) {
          if (currentRow.isExpanded && event.keyCode === keycode('left')) {
            event.preventDefault();
            currentRow.toggleRowExpanded();
            return;
          } else if (!currentRow.isExpanded && event.keyCode === keycode('right')) {
            event.preventDefault();
            currentRow.toggleRowExpanded();
            return;
          }
        } // inline editing


        if (currentRow.toggleRowEditing) {
          if (currentRow.canEdit && !currentRow.isEditing) {
            if (rowProps.onRowCreate && event.shiftKey && event.keyCode === keycode('n')) {
              event.preventDefault();

              if (!currentRow.isExpanded) {
                currentRow.toggleRowExpanded();
              }

              rowProps.onRowCreate(sanitizedRow, event);
              return;
            }

            if (event.keyCode === keycode('e')) {
              event.preventDefault();
              currentRow.toggleRowEditing();
              return;
            }
          }
        }

        if (rowProps.onRowEdit && event.keyCode === keycode('e') && !isModifierKeyPressed) {
          event.preventDefault();
          rowProps.onRowEdit(sanitizedRow, event);
          return;
        }

        if (rowProps.onRowCopy && event.keyCode === keycode('c') && !isModifierKeyPressed) {
          event.preventDefault();
          rowProps.onRowCopy(sanitizedRow, event);
          return;
        }

        if (rowProps.onRowDelete && event.keyCode === keycode('delete') && !isModifierKeyPressed) {
          event.preventDefault();
          rowProps.onRowDelete(sanitizedRow, event);
          return;
        }
      }
    }

    var nextIndex = getNextIndexFromKeycode(event.keyCode, rows.length, activeIndex);

    if (nextIndex !== undefined) {
      event.preventDefault();
      setActiveIndex(nextIndex);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!useGlobalKeyboardNavigation) {
      onKeyDown(event.nativeEvent);
    }
  };

  React__default.useEffect(function () {
    if (useGlobalKeyboardNavigation) {
      window.top.addEventListener('keydown', onKeyDown);
    }

    return function () {
      if (useGlobalKeyboardNavigation) {
        window.top.removeEventListener('keydown', onKeyDown);
      }
    };
  }, [onKeyDown]);

  var handleFocus = function handleFocus() {
    if (activeIndex === undefined && rows.length) {
      setActiveIndex(0);
    }
  };

  return [activeIndex, setActiveIndex, handleKeyDown, handleFocus];
};

export { useTableKeyboardNavigation };
//# sourceMappingURL=useTableKeyboardNavigation.js.map
